import { Component, HostBinding } from '@angular/core';

@Component({
  standalone: false,
  selector: 'polpo-legals-hero',
  templateUrl: './legals-hero.component.html',
})
export class LegalsHeroComponent {
  @HostBinding('class') defaultClasses = ['block', 'overflow-hidden'];
}
